const CHUNK_LOAD_ERROR_NAME = "ChunkLoadError";
// Tolerates the RetryChunkLoadPlugin rewritten message ("Loading chunk N failed after 2 retries.") and CSS chunks
const CHUNK_LOAD_MESSAGE_PATTERN = /Loading (CSS )?chunk .+ failed/i;

export function isChunkLoadError(error: unknown): boolean {
  if (typeof error === "string") {
    return CHUNK_LOAD_MESSAGE_PATTERN.test(error);
  }

  if (!(error instanceof Error)) {
    return false;
  }

  if (error.name === CHUNK_LOAD_ERROR_NAME) {
    return true;
  }

  return CHUNK_LOAD_MESSAGE_PATTERN.test(error.message);
}
